import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import type { ProxyConfigBasic } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import Actions from './row/components/actions';
type MobileRowProps = {
  proxyConfig: ProxyConfigBasic;
};
const MobileRow = t0 => {
  const $ = _c(26);
  const {
    proxyConfig
  } = t0;
  const {
    t
  } = useTranslation("vault-proxy");
  const {
    formatDateWithTime
  } = useIntl();
  const {
    name,
    url,
    method,
    status,
    createdAt
  } = proxyConfig;
  let t1;
  if ($[0] !== name) {
    t1 = <p className="text-label-2">{name}</p>;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== method || $[3] !== url) {
    t2 = <span className="whitespace-normal wrap-anywhere text-body-3 text-tertiary">{method} · {url}</span>;
    $[2] = method;
    $[3] = url;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = status === "disabled" ? "text-error" : undefined;
  let t4;
  if ($[5] !== status || $[6] !== t) {
    t4 = status === "enabled" ? t(_temp) : t(_temp2);
    $[5] = status;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== createdAt || $[12] !== formatDateWithTime) {
    t6 = formatDateWithTime(new Date(createdAt));
    $[11] = createdAt;
    $[12] = formatDateWithTime;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <p className="text-body-3 text-tertiary">{t5}{" "}· {t6}</p>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t7) {
    t8 = <td><div className="flex flex-col gap-0.5 py-2">{t1}{t2}{t7}</div></td>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== proxyConfig) {
    t9 = <td aria-label="actions"><Actions proxyConfig={proxyConfig} /></td>;
    $[21] = proxyConfig;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default MobileRow;
function _temp($) {
  return $.status.enabled;
}
function _temp2($_0) {
  return $_0.status.disabled;
}